import { defineComponent as _defineComponent } from 'vue';
import { createVNode as _createVNode, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createElementVNode as _createElementVNode, createCommentVNode as _createCommentVNode } from "vue";
const _hoisted_1 = {
    key: 0,
    class: "mt-6"
};
const _hoisted_2 = {
    key: 1,
    class: "usedVouchers"
};
const _hoisted_3 = { key: 2 };
import { ref, onMounted } from 'vue';
import { useRouter } from 'vue-router';
import { useAppState } from '@/composables/useAppState';
import { useAuth } from '@/composables/useAuth';
import { useCustomer } from '@/composables/useCustomer';
import { useVouchers } from '@/composables/useVouchers';
import HeaderBlock from './elements/HeaderBlock.vue';
import GroupedVoucherList from './elements/GroupedVoucherList.vue';
export default /*@__PURE__*/ _defineComponent({
    __name: 'MyArchivedVouchersPage',
    setup(__props) {
        const router = useRouter();
        const state = useAppState();
        useAuth();
        const { getCustomer } = useCustomer();
        const { getCustomerVouchersGroupedByMerchant, getCustomerVouchers } = useVouchers();
        const archivedVouchers = ref([]);
        const selectedMerchantId = ref(null);
        function onLoad() {
            getCustomer();
            getCustomerVouchersGroupedByMerchant(null, true);
        }
        function handleBack() {
            if (!selectedMerchantId.value) {
                router.back();
            }
            getCustomerVouchersGroupedByMerchant(null, true, true);
            selectedMerchantId.value = null;
        }
        function handleGroupVoucherClick(voucher) {
            selectedMerchantId.value = voucher.merchantId;
            getCustomerVouchers(() => {
                state.groupedVouchers = state.vouchers;
            }, selectedMerchantId.value, true, true);
        }
        function handleVoucherClicked(voucher) {
            router.push('/MyVouchers/Merchants/' + voucher.id + '?archive=true');
        }
        onMounted(() => {
            onLoad();
        });
        return (_ctx, _cache) => {
            const _component_v_skeleton_loader = _resolveComponent("v-skeleton-loader");
            return (_openBlock(), _createElementBlock(_Fragment, null, [
                _createVNode(HeaderBlock, {
                    title: "Archived Vouchers",
                    logicalBack: true,
                    onLogicalBack: _cache[0] || (_cache[0] = ($event) => (handleBack()))
                }),
                (!_unref(state).groupedVouchers)
                    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
                        (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
                            return _createElementVNode("div", {
                                key: i,
                                class: "mb-2"
                            }, [
                                _createVNode(_component_v_skeleton_loader, { type: "list-item-avatar-two-line" })
                            ]);
                        }), 64))
                    ]))
                    : (_unref(state).groupedVouchers && _unref(state).groupedVouchers.length != 0)
                        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
                            _createElementVNode("div", null, [
                                _createVNode(GroupedVoucherList, {
                                    vouchers: _unref(state).groupedVouchers,
                                    formatter: _unref(state).formatter,
                                    onGroupClicked: handleGroupVoucherClick,
                                    onVoucherClicked: handleVoucherClicked,
                                    merchantId: selectedMerchantId.value
                                }, null, 8, ["vouchers", "formatter", "merchantId"])
                            ])
                        ]))
                        : (_unref(state).groupedVouchers && _unref(state).groupedVouchers.length == 0)
                            ? (_openBlock(), _createElementBlock("div", _hoisted_3, _cache[1] || (_cache[1] = [
                                _createElementVNode("p", { class: "centered" }, "You have no archived vouchers.", -1)
                            ])))
                            : _createCommentVNode("", true)
            ], 64));
        };
    }
});
